// extracted by mini-css-extract-plugin
export var content = "_r3-1";
export var noScroll = "_r3-3";
export var paper = "_r3-0";
export var scrollable = "_r3-2";